export enum BulletinStepEnum {
  SELECT_NEWS,
  SUMMARY
}
